export const defaultTitle =
  'Welltory - guide to a life of health and productivity';
export const defaultDescription =
  'Helping millions reach peak health and productivity. A guide that navigates you to the summit of your potential.';
export const defaultOgDescription =
  'Helping millions reach peak health and productivity. A guide that navigates you to the summit of your potential.';

export const jsonLd = {
  '@context': 'http://schema.org',
  '@type': 'Corporation',
  name: 'Welltory',
  description:
    'A Heart Rate Variability App that navigates you to the summit of your potential.',
  logo: 'https://app.welltory.com/favicons/android-chrome-512x512.png',
  url: 'https://welltory.com/',
  email: 'mailto:hello@welltory.com',
  sameAs: [
    'https://twitter.com/welltory',
    'https://www.linkedin.com/company/welltory',
    'https://www.facebook.com/welltory',
    'https://www.youtube.com/c/Welltoryapp/featured',
    'https://www.instagram.com/welltory/',
    'https://www.crunchbase.com/organization/welltory',
    'https://www.quora.com/profile/Welltory-2',
    'https://www.stitcher.com/show/welltory',
    'https://www.spreaker.com/show/welltory',
    'https://en.everybodywiki.com/Welltory_(app)',
    'https://medium.com/@welltory',
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: '541 Jefferson Avenue',
    addressLocality: 'Redwood City',
    addressRegion: 'CA',
    postalCode: '94063',
    addressCountry: 'United States',
  },
};
